document.addEventListener('DOMContentLoaded', function() {
  // Check if the URL parameter option=pdp-option2 is present
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('option') === 'pdp-option2') {
    // Subscribe to the expivi event only if the condition is met
    window.expivi._events.onChange.subscribe(function(e) {
      if (e.name === "fully_loaded") {		 
        expivi.setProductAttributeByKey('prepared_design', 'prepared_design_no');
      }
    });
  }
});